import { render, staticRenderFns } from "./characters.vue?vue&type=template&id=15c1ad54&scoped=true"
import script from "./characters.vue?vue&type=script&lang=js"
export * from "./characters.vue?vue&type=script&lang=js"
import style0 from "./characters.vue?vue&type=style&index=0&id=15c1ad54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1ad54",
  null
  
)

export default component.exports